import React from 'react';

const Warning = ({ fill = 'none' }) => {
  return (
    <svg width="22" height="18" viewBox="0 0 22 18" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.266 17.9981H1.73301C1.37575 17.9981 1.04563 17.8075 0.867 17.4981C0.688374 17.1887 0.688376 16.8075 0.867007 16.4981L10.133 0.498114C10.3118 0.189226 10.6416 -0.000976562 10.9985 -0.000976562C11.3554 -0.000976562 11.6852 0.189226 11.864 0.498114L21.13 16.4981C21.3085 16.8074 21.3086 17.1883 21.1303 17.4977C20.9519 17.807 20.6221 17.9977 20.265 17.9981H20.266ZM10 12.9981V14.9981H10.933H10.998H11.063H11.998V12.9981H10ZM10 5.99811V10.9981H12V5.99811H10Z"
        fill={fill}
      />
    </svg>
  );
};

export default Warning;
